<template>
  <div
    v-if="show"
    class="fixed inset-0 flex items-center justify-center bg-black/70 z-50 px-4"
  >
    <div
      class="relative w-full max-w-3xl bg-[#121212] border border-[#00F0FF]/20 rounded-[16px] shadow-[0_0_30px_#00F0FF15] text-white overflow-hidden"
    >
      <!-- Close Button -->
      <button
        @click="$emit('close')"
        class="absolute top-2 right-5 text-white text-3xl font-bold hover:text-black transition-colors z-10"
      >
        &times;
      </button>

      <!-- Modal Header -->
      <div
        class="bg-gradient-to-r from-[#00F0FF] to-[#1ED6FF] p-4 text-black text-start text-sm font-bold uppercase tracking-wider rounded-t-2xl"
      >
        {{ $t('Modal.HowRafflesWorkModal.Header') }}
      </div>

      <!-- Modal Content -->
      <div class="p-6 text-sm space-y-4 max-h-[75vh] overflow-y-auto custom-scrollbar">
        <h2 class="font-bold text-lg">{{ $t('Modal.HowRafflesWorkModal.Section1Title') }}</h2>
        <p class="text-white/70">
          {{ $t('Modal.HowRafflesWorkModal.Section1Desc1') }}
        </p>
        <p class="text-white/70">
          {{ $t('Modal.HowRafflesWorkModal.Section1Desc2') }}
        </p>
        <ul class="text-white/70 list-disc pl-6">
          <li>
            <strong>{{ $t('Modal.HowRafflesWorkModal.Param_N') }}</strong> {{ $t('Modal.HowRafflesWorkModal.Param_N_Desc') }}
          </li>
          <li><strong>{{ $t('Modal.HowRafflesWorkModal.Param_Min') }}</strong> {{ $t('Modal.HowRafflesWorkModal.Param_Min_Desc') }}</li>
          <li>
            <strong>{{ $t('Modal.HowRafflesWorkModal.Param_Max') }}</strong> {{ $t('Modal.HowRafflesWorkModal.Param_Max_Desc') }}
          </li>
          <li>
            <strong>{{ $t('Modal.HowRafflesWorkModal.Param_Data') }}</strong> {{ $t('Modal.HowRafflesWorkModal.Param_Data_Desc') }}
          </li>
          <li>
            <strong>{{ $t('Modal.HowRafflesWorkModal.Param_Completion') }}</strong> {{ $t('Modal.HowRafflesWorkModal.Param_Completion_Desc') }}
          </li>
        </ul>

        <h2 class="font-bold text-lg mt-4">{{ $t('Modal.HowRafflesWorkModal.Section2Title') }}</h2>
        <p class="text-white/70">
          {{ $t('Modal.HowRafflesWorkModal.Section2Desc1') }}
        </p>

        <p class="text-white/70">
          {{ $t('Modal.HowRafflesWorkModal.Section2Desc2') }}
        </p>

        <h3 class="font-bold text-lg mt-4">{{ $t('Modal.HowRafflesWorkModal.HowToVerify') }}</h3>
        <ol class="text-white/70 mt-2 list-decimal pl-5">
          <li>
            {{ $t('Modal.HowRafflesWorkModal.Step1') }}
            <a href="https://www.random.org/" class="text-[#00F0FF] underline"
              >{{ $t('Modal.HowRafflesWorkModal.Step1Link') }}</a
            >{{ $t('Modal.HowRafflesWorkModal.Step1End') }}
          </li>
          <li>{{ $t('Modal.HowRafflesWorkModal.Step2') }}</li>
          <li>{{ $t('Modal.HowRafflesWorkModal.Step3') }}</li>
          <li>{{ $t('Modal.HowRafflesWorkModal.Step4') }}</li>
        </ol>

        <h3 class="font-bold text-lg mt-4">{{ $t('Modal.HowRafflesWorkModal.SampleObject') }}</h3>
        <pre class="bg-black p-4 rounded-xl text-green-400 mt-4 text-xs overflow-auto">
{
  "method": "generateSignedIntegers",
  "hashedApiKey": "J9lfnxC9OIG6TFv4GtRNHx+w3zPhScCgjSccUP9Gqyl12L6WIyGopJ5lIxBG457Zm7UIeIhOr1Uc+T5GpLTy1A==",
  "n": 1,
  "min": 1,
  "max": 10,
  "replacement": false,
  "base": 10,
  "pregeneratedRandomization": null,
  "data": [7],
  "license": {
    "type": "developer",
    "text": "Random values licensed strictly for development and testing only",
    "infoUrl": null
  },
  "licenseData": null,
  "userData": null,
  "ticketData": null,
  "completionTime": "2025-03-30 11:35:25Z",
  "serialNumber": 35
}
        </pre>

        <h2 class="font-bold text-lg mt-4">{{ $t('Modal.HowRafflesWorkModal.CommitmentTitle') }}</h2>
        <p class="text-white/70">
          {{ $t('Modal.HowRafflesWorkModal.CommitmentDesc') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #1A1D24;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #00f0ff;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #1ed6ff;
}
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #00f0ff #1A1D24;
}
</style>
